
import * as d3 from 'd3';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IAnswerCountPerPoint } from '../../shared/contracts/KPIContract';

interface Data { value: number; class: string; }
@Component
export default class PieChart extends Vue {
  @Prop() value: IAnswerCountPerPoint;

  private width: number = 220;
  private height: number = 160;
  private svgElement: any = undefined;

  private translateArcs = ``;

  mounted() {
    this.svgElement = d3.select(this.$el).select('svg');
    this.translateArcs = `translate(${this.width / 2}, 98)`;
    this.drawPieChart();
  }

  private drawPieChart() {
    this.svgElement
        .selectAll('*')
        .remove();

    const svg = this.svgElement
        .append('g')
        .attr('transform', this.translateArcs);

    const data: Data[] = [
      {value: this.value.Negative, class: 'pie-chart-path--negative'},
      {value: this.value.Neutral, class: 'pie-chart-path--neutral'},
      {value: this.value.Positive, class: 'pie-chart-path--positive'}
    ];

    const radius = Math.min(this.width, this.height) / 2;

    const arc = d3
        .arc()
        .innerRadius(0)
        .outerRadius(radius);

    const pie = d3
        .pie<Data>()
        .value((d: Data) => d.value);

    svg.selectAll('path')
        .data(pie(data))
        .enter()
        .append('g')
        .append('path')
        .attr('d', arc)
        .attr('class', (d: any) => `pie-chart-path ${d.data.class}`)
        .style('opacity', '0.8');
  }
}
